import React from 'react';
import {
  ButtonView,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogFooterProps,
  DialogHeader,
  DialogHeaderProps,
  DialogProps,
} from '@gravity-ui/uikit';
import styles from './ActionModal.module.scss';

type ActionModalProps = Omit<DialogProps, 'onClose'> &
  DialogHeaderProps &
  DialogFooterProps & {
    open: boolean;
    setOpen: (open: boolean) => void;
    onClose?: () => void;
    children: React.ReactNode;
    resetForm?: () => void;
    submitForm: () => void;
    isLoading?: boolean;
    buttonsSize: 's' | 'm' | 'l';
    viewActionButton?: ButtonView;
    isDisabled?: boolean;
  };

export const ActionModal = ({
  open,
  setOpen,
  onClose,
  children,
  resetForm,
  isLoading,
  submitForm,
  buttonsSize,
  isDisabled = false,
  viewActionButton = 'action',
  ...props
}: ActionModalProps) => {
  return (
    <Dialog
      size={props.size}
      hasCloseButton
      open={open}
      onClose={() => {
        resetForm?.();
        setOpen(false);
      }}>
      <DialogHeader caption={props.caption} />
      <DialogBody>
        <form className={styles.form}>{children}</form>
      </DialogBody>
      <DialogFooter
        onClickButtonCancel={() => {
          resetForm?.();
          setOpen(false);
        }}
        onClickButtonApply={() => submitForm()}
        propsButtonApply={{size: buttonsSize, loading: isLoading, view: viewActionButton, disabled: isDisabled}}
        propsButtonCancel={{size: buttonsSize}}
        textButtonApply={props.textButtonApply}
        textButtonCancel={props.textButtonCancel}
      />
    </Dialog>
  );
};
